import { render, staticRenderFns } from "./TopVacanciesInner.vue?vue&type=template&id=5352b448&"
import script from "./TopVacanciesInner.vue?vue&type=script&lang=js&"
export * from "./TopVacanciesInner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports